/**
 * Contract Enums - Đồng bộ với backend Laravel/NestJS
 * Không hardcode string/number trong component
 */

/**
 * Contract Type Enum
 * Đồng bộ với backend enum
 */
export const ContractTypeEnum = {
  STANDARD: '1',
  PREMIUM: '2',
  VIP: '3'
};

/**
 * Contract Status Enum
 * Đồng bộ với backend enum
 */
export const ContractStatusEnum = {
  DRAFT: 'draft',
  ACTIVE: 'active',
  EXPIRED: 'expired',
  CANCELLED: 'cancelled'
};

/**
 * Payment Method Enum
 * Đồng bộ với backend enum
 */
export const PaymentMethodEnum = {
  CASH: 1,
  BANK_TRANSFER: 2,
  CREDIT_CARD: 3,
  INSTALLMENT: 4
};

/**
 * Validation Field Labels Enum
 * Để hiển thị label đầy đủ bằng tiếng Việt trong error
 */
export const ContractFieldLabelEnum = {
  CUSTOMER_NAME: 'Họ và tên',
  CUSTOMER_EMAIL: 'Email',
  CUSTOMER_PHONE: 'Số điện thoại',
  CUSTOMER_BIRTHDAY: 'Ngày sinh',
  CUSTOMER_ADDRESS: 'Địa chỉ',
  CUSTOMER_CCCD: 'CCCD',
  CENTER_ID: 'Trung tâm',
  BRANCH_ID: 'Chi nhánh',
  COURSE_IDS: 'Khóa học',
  TUITION_PAYMENT_ID: 'Hình thức đóng học phí',
  TVV_ID: 'Mã tư vấn',
  USER_INTRO_ID: 'Mã giới thiệu',
  PROMOTION_IDS: 'Mã khuyến mại',
  TYPE: 'Loại hợp đồng'
};

/**
 * Validation Error Codes Enum
 * Đồng bộ với backend error codes
 */
export const ValidationErrorCodeEnum = {
  REQUIRED_FIELD: 'REQUIRED_FIELD',
  INVALID_FORMAT: 'INVALID_FORMAT',
  INVALID_VALUE: 'INVALID_VALUE',
  DUPLICATE_VALUE: 'DUPLICATE_VALUE',
  NOT_FOUND: 'NOT_FOUND'
};
